import { MeterBalance } from '@/src/api/payg';
import { PAYG_EVENTS } from '@/src/constants/analytics';
import AnalyticsService from '@/src/services/analyticsService';
import { formatCurrencyValue } from '@/src/utils/money';
import { Button, Margin } from '@ovotech/element-v5';
import React, { useEffect } from 'react';
import { BaseBalanceCard } from './BaseBalanceCard';
import { StyledBalance, StyledDarkGreenLabel } from './styles';
import { getFormattedTimestamp } from './utils';

interface Props extends MeterBalance {
  onClick?: () => void;
  onInfoClick: () => void;
}

export const SmartMeterBalanceCard = ({
  onClick,
  onInfoClick,
  balance,
  date,
  fuel,
}: Props) => {
  const isRoundPoundsAmount = balance % 1 === 0;

  useEffect(() => {
    AnalyticsService.dispatch(
      ...PAYG_EVENTS.balanceCardViewed({ fuel, type: 'smart' }),
    );
  }, [fuel]);

  return (
    <BaseBalanceCard
      fuel={fuel}
      onInfoClick={() => {
        AnalyticsService.dispatch(
          ...PAYG_EVENTS.balanceCardPressedInfo({ fuel }),
        );
        onInfoClick();
      }}
    >
      <StyledBalance semanticComponent="h4">
        {formatCurrencyValue(
          { unit: 'GBP', dp: isRoundPoundsAmount ? 0 : 2 },
          { amount: balance.toString(), currencyUnit: 'GBP' },
        )}
      </StyledBalance>
      <Margin top={2} bottom={6}>
        <StyledDarkGreenLabel>
          Balance updated: {getFormattedTimestamp(date)}
        </StyledDarkGreenLabel>
      </Margin>
      {onClick && (
        <Button iconRight="arrow-right" onClick={onClick}>
          Top-up
        </Button>
      )}
    </BaseBalanceCard>
  );
};
